import styled from "../../__compat__/styled-components/main.entry.mjs.mjs";
import React from "../../__compat__/react/main.entry.mjs.mjs";
import { injectTypography } from "../../utils/injectTypography.mjs.mjs";
import { injectSpacing } from "../../api/spacing/injectSpacing.mjs.mjs";
import { injectOSXFontSmoothing } from "../../utils/injectOSXFontSmoothing.mjs.mjs";
import { Button } from "../index.mjs.mjs";
export const StyledLink = styled.a.withConfig({ displayName: "auir-611444a-StyledLink", componentId: "auir-611444a-1k68yz5" }) `
  color: var(${(props) => props.theme.colors.interaction.secondary.default});
  text-decoration: none;
  cursor: pointer;

  &:hover {
    color: var(${(props) => props.theme.colors.interaction.secondary.hover});
  }
`;
export const StyledBreadcrumbItem = styled.li.withConfig({ displayName: "auir-611444a-StyledBreadcrumbItem", componentId: "auir-611444a-108imr4" }) `
  color: var(${(props) => props.theme.colors.interaction.secondary.default});
  list-style: none;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    color: var(${(props) => props.theme.colors.interaction.secondary.hover});
  }

  &:not(:first-child)::before {
    content: '<';
    color: var(${(props) => props.theme.colors.ui.tertiary});
    padding-right: var(${(props) => props.theme.responsive.spacing.s});
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.l}px) {
    &:last-child {
      color: var(${(props) => props.theme.colors.interaction.secondary.active});
      cursor: default;
    }
  }
`;
export const StyledBreadcrumb = styled.ul.withConfig({ displayName: "auir-611444a-StyledBreadcrumb", componentId: "auir-611444a-1b8jbg9" }) `
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  ${(props) => injectTypography(props, 'copy2')}
  ${injectOSXFontSmoothing(true)}
  padding: 0px;
  margin: 0;
  ${injectSpacing('margin')}

  ${StyledBreadcrumbItem} {
    &:not(:nth-last-child(2)) {
      display: none;
    }

    &:not(:first-child)::before {
      content: ${(props) => (props.onlyShowPrevPage ? '"<"' : '">"')};
      padding: 0 var(${(props) => props.theme.responsive.spacing.s});
    }

    &:not(:nth-last-child(2)) {
      display: ${(props) => (props.onlyShowPrevPage ? 'none' : 'flex')};
    }
  }
`;
export const StyledCollapsedBreadcrumbItemGroup = styled.li.withConfig({ displayName: "auir-611444a-StyledCollapsedBreadcrumbItemGroup", componentId: "auir-611444a-1pogir8" }) `
  display: none;
  height: var(${(props) => props.theme.responsive.typography.copy2.lineHeight});

  @media (min-width: ${({ theme }) => theme.breakpoints.l}px) {
    align-items: center;
    display: flex;
    content: '<';
    margin-right: -12px;
    color: var(${(props) => props.theme.colors.interaction.secondary.default});

    &:hover {
      color: var(${(props) => props.theme.colors.interaction.secondary.hover});
    }

    &:active {
      color: var(${(props) => props.theme.colors.interaction.secondary.active});
    }

    &:before {
      content: '>';
      color: var(${(props) => props.theme.colors.ui.tertiary});
      padding-left: var(${(props) => props.theme.responsive.spacing.s});
    }
  }
`;
export const StyledBreadcrumbPopoverLiteTrigger = styled((props) => (React.createElement(Button, { ...props }))).withConfig({ displayName: "auir-611444a-StyledBreadcrumbPopoverLiteTrigger", componentId: "auir-611444a-uqycwc" }) `
  svg {
    color: var(${(props) => props.theme.colors.interaction.secondary.default});

    &:hover {
      color: var(${(props) => props.theme.colors.interaction.secondary.hover});
    }

    &:active {
      color: var(${(props) => props.theme.colors.interaction.secondary.active});
    }
  }
`;
export const StyledCollapsedBreadcrumbList = styled.ul.withConfig({ displayName: "auir-611444a-StyledCollapsedBreadcrumbList", componentId: "auir-611444a-1sl2ike" }) `
  ${(props) => injectTypography(props, 'copy2')}
  ${injectOSXFontSmoothing(true)}
  padding: 0px;

  ${StyledBreadcrumbItem} {
    &:not(:last-child) {
      margin-bottom: var(${(props) => props.theme.responsive.spacing.xs});
    }

    &::before {
      display: none;
    }
  }
`;
//# sourceMappingURL=Breadcrumb.styles.mjs.mjs.map